
import Vue from 'vue'
import _ from 'lodash'
import { DEFAULT_PAGE_SIZE } from '@/config/app'
import { i18n } from '@/i18n'

const getDefaultState = () => {
  return {
    paginationInfo: {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: null,
    order: null,
    filters: [],
    masterFilters: {
      id: { label: i18n.t('configurations.id'), value: '' },
      name: { label: i18n.t('configurations.name'), value: '' },
      tipoGrupo: { label: i18n.t('configurations.type'), value: '' },
      enUso: { label: i18n.t('tags.used'), value: '' },
      verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
      verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
      verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
      send_alerts: { label: 'Enviar avisos', value: '' },
      email: { label: i18n.t('configurations.email'), value: '' },
    },
    notUseLikeTags: ['results', 'page', 'sort', 'order', 'status'],
    kendo: {
      columns: [
        { field: 'selected', width: '50px', minResizableWidth: 25, headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
        { field: 'IdGrupo', width: '100px', minResizableWidth: 50, title: i18n.t('configurations.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
        { field: 'Nombre', width: '250px', minResizableWidth: 125, title: i18n.t('configurations.name'), columnMenu: 'myTemplate', locked: false },
        { field: 'Tipo', width: '200px', minResizableWidth: 100, title: i18n.t('configurations.type'), columnMenu: 'myTemplate', locked: false },
        {
          field: 'Usuarios',
          width: '440px',
          minResizableWidth: 220,
          title: i18n.t('configurations.users'),
          columnMenu: 'myTemplate',
          locked: false,
          cell: 'tagsTemplate',
          type: 'boolean',
          sortable: false,
          groupable: false
          // sortable: {
          //   compare: function (a, b) {
          //     return a.Tags.length - b.Tags.length
          //   }
          // }
        },
        { field: 'EnUso', width: '225px', minResizableWidth: 112, title: i18n.t('tags.used'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        {
          field: 'EstadosDescarga',
          width: '440px',
          minResizableWidth: 220,
          title: i18n.t('configurations.status'),
          columnMenu: 'myTemplate',
          locked: false,
          cell: 'tagsTemplate',
          type: 'boolean',
          hidden: true,
          sortable: false,
          groupable: false
        },
        { field: 'VerTodoGrupos', width: '225px', minResizableWidth: 112, title: i18n.t('configurations.ver_todo_groups'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'VerTodoEstados', width: '225px', minResizableWidth: 112, title: i18n.t('configurations.ver_todo_statuses'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'VerTodoEmpresas', width: '225px', minResizableWidth: 112, title: i18n.t('configurations.ver_todo_companies'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'VerTodoAsignarGrupos', width: '500px', minResizableWidth: 250, title: i18n.t('configurations.ver_todo_groups_asign'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate', hidden: true },
        { field: 'EmailAvisoNueva', title: i18n.t('companies.email_alerts'), columnMenu: 'myTemplate', width: '275px', minResizableWidth: 137, locked: false },
        { field: 'EmailDiasAviso', title: i18n.t('companies.email_ultima_llamada'), columnMenu: 'myTemplate', width: '375px', minResizableWidth: 187, locked: false },
        { field: 'EmailAvisoTramitacionUrgente', title: i18n.t('companies.email_tramitacion_urgente'), columnMenu: 'myTemplate', width: '375px', minResizableWidth: 187, locked: false },
        { field: 'EmailAvisoErrores', title: i18n.t('companies.email_neos_error'), columnMenu: 'myTemplate', width: '375px', minResizableWidth: 187, locked: false },
        { field: 'AgruparEmailsAvisos', title: i18n.t('configurations.mails_group_status'), columnMenu: 'myTemplate', width: '450px', minResizableWidth: 225, locked: false, cell: 'checkboxTemplate' },
        { field: 'EnviarAvisos', width: '150px', minResizableWidth: 75, title: i18n.t('companies.send_alerts'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'EnviarAvisosUsuarios', width: '250px', minResizableWidth: 125, title: i18n.t('configurations.send_alerts_users'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'DiasAviso', width: '425px', minResizableWidth: 212, title: i18n.t('companies.download_alert_days_form'), columnMenu: 'myTemplate', locked: false },
        { field: 'DiasFinTramite', width: '400px', minResizableWidth: 200, title: i18n.t('companies.end_alert_days_label_form'), columnMenu: 'myTemplate', locked: false },
        { field: 'EmailAvisoDescargada', title: i18n.t('companies.email_downloads'), columnMenu: 'myTemplate', width: '300px', minResizableWidth: 150, locked: false },
        { field: 'NumeroSMSDescargadas', title: i18n.t('companies.sms_downloads'), hidden: true, columnMenu: 'myTemplate', width: '425px', minResizableWidth: 212, locked: false },
        { field: 'EmailAvisoTramitada', title: i18n.t('companies.email_tramitada'), columnMenu: 'myTemplate', width: '300px', minResizableWidth: 150, locked: false },
        { field: 'EmailAvisoVinculaciones', title: i18n.t('companies.email_aviso_vincul'), hidden: true, columnMenu: 'myTemplate', width: '400px', minResizableWidth: 200, locked: false },
        { field: 'EmailAvisoPrincipal', title: i18n.t('companies.email_aviso_princ'), hidden: true, columnMenu: 'myTemplate', width: '400px', minResizableWidth: 200, locked: false },
        { field: 'EmailAvisoSecundario', title: i18n.t('companies.email_aviso_sec'), hidden: true, columnMenu: 'myTemplate', width: '400px', minResizableWidth: 200, locked: false },
      ],
      skip: 0,
      take: 10,
      sortable: true,
      sort: [],
      group: [],
      reorderable: true,
      groupable: true,
      filter: null,
      columnMenu: true,
      dataResult: null,
      // detail: 'myTemplateExpanded',
    },
  }
}

const state = getDefaultState()

const getters = {
  getKendo: state => state.kendo,
  getPayloadCurrentPage: state => state.paginationInfo.currentPage,
  getPayloadPageSize: state => state.paginationInfo.pageSize,
  getPayloadTotal: state => state.paginationInfo.total,
  getPayLoadTotalPages: state => state.paginationInfo.totalPages,
  getMasterFilters: state => state.masterFilters,
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getPaginationInfo: state => {
    state.paginationInfo.pageSize = state.pageSize
    return state.paginationInfo
  },
  getFilters: (state) => {
    state.filters.results = state.pageSize
    state.filters.page = state.currentPage
    if (state.order) {
      state.filters.order = state.order
    } else {
      delete (state.filters.order)
    }
    if (state.sort && state.filters.order) {
      state.filters.sort = state.sort
    } else {
      delete (state.filters.sort)
    }
    return state.filters
  },
  getTags: (state) => {
    const tags = []
    _.each(state.filters, (item, key) => {
      if (state.notUseLikeTags.indexOf(key) === -1) {
        tags.push([key, item.label, item.value])
      }
    })
    return tags
  },
  getAppliedFilters (state) {
    const data = {}
    const _temp = Object.entries(state.masterFilters)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.filters = data
    return data
  }
}

const mutations = {
  setKendoColumns (state, data) {
    data.unshift('selected')
    state.kendo.columns = state.kendo.columns.map(x => {
      if (data.includes(x.field)) {
        x.hidden = false
      } else {
        x.hidden = true
        data.push(x.field)
      }
      return x
    }).sort((a, b) => data.indexOf(a.field) - data.indexOf(b.field))
  },
  setKendo (state, kendo) {
    state.kendo = kendo
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  resetStateWithoutSort (state, data) {
    Object.assign(state, getDefaultState())
    // Object.assign(state, getDefaultState())
    state.kendo.sort = data.sort
    state.kendo.group = data.group
  },
  resetPaginationInfo (state, data) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.paginationInfo = {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  setPaginationInfo (state, data) {
    state.paginationInfo = data
  },
  setSort (state, fieldName) {
    state.sort = fieldName
  },
  setSortOrder (state, order) {
    switch (order) {
      case 'ascending':
        state.order = 'asc'
        break
      case 'descending':
        state.order = 'desc'
        break
      default:
        state.order = null
        state.sort = null
    }
  },
  setNotUseLikeTags (state, items = []) {
    state.notUseLikeTags = items
  },
  setMasterFilters (state, master) {
    const data = {}
    const _temp = Object.entries(master)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.masterFilters = data
    // console.log(data)
  },
  removeTag (state, tag) {
    const path = tag.split('.')
    if (path.length === 1) {
      state.masterFilters[path[0]] = ''
    }
    if (path.length === 2) {
      state.masterFilters[path[0]][path[1]] = ''
    }
  },
  resetMasterFilters (state) {
    state.masterFilters = {
      id: { label: i18n.t('configurations.id'), value: '' },
      name: { label: i18n.t('configurations.name'), value: '' },
      tipoGrupo: { label: i18n.t('configurations.type'), value: '' },
      enUso: { label: i18n.t('tags.used'), value: '' },
      verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
      verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
      verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
      send_alerts: { label: 'Enviar avisos', value: '' },
      email: { label: i18n.t('configurations.email'), value: '' },
    }
  },
  setFilter (state, { key, value }) {
    Vue.set(state.filters, { key: value })
  },
  setFilters (state, thefilters) {
    Vue.set(state, 'filters', thefilters)
  },
  clearFilters (state) {
    Vue.set(state, 'filters', [])
  },
  clearPagination (state) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.currentPage = 1
  },
  setPageSize (state, size) {
    state.pageSize = size
  },
  setCurrentPage (state, pageNumner) {
    if (pageNumner > 0 && pageNumner <= state.paginationInfo.totalPages) {
      state.currentPage = pageNumner
      state.paginationInfo.currentPage = pageNumner
    }
  }
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
  resetStateWithoutSort ({ commit, rootGetters }) {
    const data = {
      sort: rootGetters['groupgroupsPersisted/getSort'],
      group: rootGetters['groupgroupsPersisted/getGroup'],
    }
    commit('resetStateWithoutSort', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
